import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import { makeStyles } from '@material-ui/styles';
import { atomicwarType, urls } from 'utils/url'
import {
  Avatar,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText
} from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import PaymentIcon from '@material-ui/icons/Payment';
import PeopleIcon from '@material-ui/icons/PeopleOutlined';
import CodeIcon from '@material-ui/icons/Code';
import StoreIcon from '@material-ui/icons/Store';
import { ToDoList } from 'views/ToDo/ToDoList';

import gradients from 'utils/gradients';
import AuthFetch from 'utils/fetch';

const useStyles = makeStyles(theme => ({
  root: {},
  listItem: {
    '&:hover': {
      backgroundColor: theme.palette.background.default
    }
  },
  avatarBlue: {
    backgroundImage: gradients.blue
  },
  avatarGreen: {
    backgroundImage: gradients.green
  },
  avatarOrange: {
    backgroundImage: gradients.orange
  },
  avatarIndigo: {
    backgroundImage: gradients.indigo
  },
  arrowForwardIcon: {
    color: theme.palette.icon
  }
}));

const NotificationList = props => {
  const { notifications, className, ...rest } = props;

  const classes = useStyles();

  const avatars = {
    order: (
      <Avatar className={classes.avatarBlue}>
        <PaymentIcon />
      </Avatar>
    ),
    user: (
      <Avatar className={classes.avatarOrange}>
        <PeopleIcon />
      </Avatar>
    ),
    project: (
      <Avatar className={classes.avatarGreen}>
        <StoreIcon />
      </Avatar>
    ),
    feature: (
      <Avatar className={classes.avatarIndigo}>
        <CodeIcon />
      </Avatar>
    )
  };

  const [todo, setTodo] = useState([])
  useEffect(() => {
    AuthFetch(urls.allTodo.path, {}, urls.allTodo.method, atomicwarType).then((rv) => {
      setTodo(rv.Data.todo.sort(function(a, b) {return Date.parse(a.expireAt) - Date.parse(b.expireAt)}))
    })
  }, [0])

  return (
    <List
      {...rest}
      className={clsx(classes.root, className)}
      disablePadding
    >
      {todo.map((todoItem, idx) => (
        <ListItem
          className={classes.listItem}
          // divider={i < todoItem.length - 1}
          key={todoItem.name}
        >
          <ListItemText
            primary={idx + 1}
          ></ListItemText>
          <ListItemText
            primary={todoItem.name}
          />
        </ListItem>
      ))}
    </List>
  );
};

NotificationList.propTypes = {
  className: PropTypes.string,
  notifications: PropTypes.array.isRequired
};

export default NotificationList;
